import React, { useState, useEffect } from 'react';
import { API_URL } from '../config/api';
import './FeedbackCarousel.css';

const FeedbackCarousel = () => {
  const [items, setItems] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublicFeedbacks = async () => {
      try {
        const res = await fetch(`${API_URL}/api/feedbacks?filters[Active][$eq]=true`);
        const data = await res.json();
        const formatted = data.data
          ? data.data.map((item) => ({ id: item.id, ...item.attributes }))
          : [];
        setItems(formatted);
      } catch (err) {
        console.error('Error fetching public feedbacks:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicFeedbacks();
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [items.length]);

  if (loading || items.length === 0) return null;

  const current = items[currentIndex];

  return (
    <div className="feedback-carousel-wrapper">
      <div className="feedback-card" key={current.id}>
        <div className="stars">{'★'.repeat(current.Rating || 5)}</div>
        <p className="feedback-text">"{current.Comment}"</p>
        <div className="client-details">
          <strong className="client-name">{current.Name}</strong>
        </div>
      </div>

      {items.length > 1 && (
        <div className="carousel-controls">
          <div className="carousel-dots">
            {items.map((_, idx) => (
              <span 
                key={idx} 
                className={`dot ${idx === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(idx)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedbackCarousel;